import type { MenuType } from '../../../services/menu'

function getLabelIdsRecursive(menus: MenuType[]): string[] {
	const labelIds: string[] = []
	const regex = /#/g
	menus.forEach((menu) => {
		if (menu.labelId) {
			labelIds.push(menu.labelId.replace(regex, ''))
		}
		if (menu.subLabelId) {
			labelIds.push(menu.subLabelId.replace(regex, ''))
		}
		if (menu.menus) {
			labelIds.push(...getLabelIdsRecursive(menu.menus))
		}
	})
	return labelIds
}

export function getLabelsIdsFromMenu(menus: MenuType[]): string[] {
	const labelsId = getLabelIdsRecursive(menus)
	return Array.from(new Set(labelsId))
}
